import { Navigate } from "react-router-dom";
import { isLoggedIn, isTokenExpired } from "../lib/auth";

export default function ProtectedRoute({ children }) {

  const authLoginUrl = import.meta.env.VITE_AUTH_LOGIN_URL;

  if (!isLoggedIn() || isTokenExpired()) {
    localStorage.removeItem("token");
    return <Navigate to={authLoginUrl} replace />;
  }

  return children;
  // return isAdminLoggedIn()
  //   ? children
  //   : <Navigate to="/admin/login" replace />;
}
